import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation, Trans } from "react-i18next";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { ResizableBox } from "react-resizable";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import "@mdi/font/css/materialdesignicons.min.css";
import { Draggable } from "react-beautiful-dnd";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { ChromePicker } from "react-color";
import Typography from "@material-ui/core/Typography";
import Slider from "@material-ui/core/Slider";
import TextField from "@material-ui/core/TextField";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormLabel from "@material-ui/core/FormLabel";
import Collapse from "@material-ui/core/Collapse";
import Card from "@material-ui/core/Card";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import CardHeader from "@material-ui/core/CardHeader";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Divider from "@material-ui/core/Divider";
import Chip from "@material-ui/core/Chip";
import Popper from "@material-ui/core/Popper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import FormHelperText from "@material-ui/core/FormHelperText";
import { getColours } from "../util/ChartUtils";
import { Bar, Line, Pie } from "react-chartjs-2";

const elementMappings = {
  BarChart: Bar,
  LineChart: Line,
  PieChart: Pie,
};
const styles = (theme) => ({
  sectionsType: {
    marginTop: 13,
    minWidth: 182,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  section: {
    marginTop: theme.spacing(3),
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  expansionHeader: {
    border: "1px solid rgba(0, 0, 0, .125)",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
  },
  popper: {
    zIndex: 9999999999999999,
    marginTop: 10,
  },
  title: {
    marginRight: 50,
  },
});
export class ChartStepFour extends Component {
  colorDebounce = null;
  state = {
    chartOptions: {
      AreaSeries: ["color", "opacity", "stroke", "strokeWidth"], //
      VerticalBarSeries: ["color", "opacity", "stroke", "barWidth"], //
      HorizontalBarSeries: ["color", "opacity", "stroke", "barWidth"], //
      ContourSeries: ["color"], //
      HeatmapSeries: ["color", "opacity", "stroke", "strokeWidth"], //
      HexbinSeries: ["colorRange", "radius"], //
      LabelSeries: ["color"], //
      LineSeries: ["color", "opacity", "strokeWidth"], //
      LineMarkSeries: ["color", "opacity", "size", "strokeWidth"], //
      MarkSeries: ["color", "opacity", "stroke", "strokeWidth", "size"], //
      PolygonSeries: ["color"],
      WhiskerSeries: ["color", "opacity", "size", "stroke", "strokeWidth"],
    },
    color: { r: 0, g: 0, b: 0, a: 0.1 },
    strokeColour: "#000000",
    colorRange: ["#F44336", "#607d8b"],
    opacity: 1,
    strokeWidth: 2,
    barWidth: 0.5,
    size: 5,
    xAxisTitle: "",
    yAxisTitle: "",
    yAxisTitlePosition: "insideLeft",
    xAxisTitlePosition: "insideBottom",
    showLabels: false,
    seriesSettings: true,
    legendLabels: false,
    colorPopperOpen: false,
    anchorEl: null,
  };

  returnChart = (chart) => {
    let Chart = elementMappings[this.props.chart.series.chartType];
    if (
      typeof Chart === "undefined" ||
      !this.props.chart.series.y ||
      !this.props.chart.series.x
    ) {
      return null;
    }
    let dataArray = [];
    let labelArray = [];
    this.props.chart.data.forEach((item) => {
      dataArray.push(item[this.props.chart.series.y]);
      labelArray.push(item[this.props.chart.series.x]);
    });

    let data = {
      labels: labelArray,
      datasets: [
        {
          label: this.props.chart.legendLabel,
          backgroundColor:
            this.props.chart.series.chartType === "PieChart"
              ? getColours(labelArray.length, this.props.chart.patterns)
              : `rgba(${this.props.chart.color.r},${this.props.chart.color.g},${
                  this.props.chart.color.b
                },${this.props.chart.color.a})`,
          data: dataArray,
        },
      ],
    };

    let legend = {
      display: this.props.chart.legend ? true : false,
      position: this.props.chart.legendPosition,
      align: this.props.chart.legendAlign,
    };

    let scales =
      this.props.chart.series.chartType === "PieChart"
        ? {}
        : {
            xAxes: [
              {
                scaleLabel: {
                  display: !!this.props.chart.xAxisTitle,
                  labelString: this.props.chart.xAxisTitle,
                },
              },
            ],
            yAxes: [
              {
                scaleLabel: {
                  display: !!this.props.chart.yAxisTitle,
                  labelString: this.props.chart.yAxisTitle,
                },
              },
            ],
          };

    return (
      <div
        style={{
          position: "relative",
          width: this.props.chart.width,
          height: this.props.chart.height,
        }}
      >
        <Chart
          data={data}
          options={{
            responsive: true,
            legend,
            scales,
            maintainAspectRatio: false,
          }}
        />
      </div>
    );
  };

  componentDidMount() {
    if (this.props.edit && this.props.chart) {
      this.setState({ chart: this.props.chart });
    }
  }
  getRowsData = () => {
    var items = this.props.data;
    var keys = this.props.usedKeys;
    return items.map((row, index) => {
      return (
        <TableRow key={index}>
          {this.renderRow({ key: index, data: row, keys: keys })}
        </TableRow>
      );
    });
  };
  getHeader = () => {
    var keys = this.props.keys;
    if (Array.isArray(keys)) {
      return keys.map((key, index) => {
        return <TableCell key={key}>{key.toUpperCase()}</TableCell>;
      });
    }
  };
  renderRow = (props) => {
    return props.keys.map((key, idx) => {
      let renderData;
      props.data[key] instanceof Object
        ? (renderData = JSON.stringify(props.data[key]))
        : (renderData = props.data[key]);
      return <TableCell key={idx}>{renderData}</TableCell>;
    });
  };
  handleColorRangeChange = (num, color, index) => {
    let colorRange = { ...this.props.chart.series[index].colorRange };
    colorRange[num] = color.hex;
    this.setState({ colorRange: colorRange });
  };
  render() {
    const { classes, ...withoutClasses } = this.props;
    const colors = [
      "#000000",
      "#F44336",
      "#E91E63",
      "#9C27B0",
      "#673ab7",
      "#3f51b5",
      "#2196f3",
      "#03a9f4",
      "#00bcd4",
      "#009688",
      "#4caf50",
      "#8bc34a",
      "#cddc39",
      "#ffeb3b",
      "#ffc107",
      "#ff9800",
      "#ff5722",
      "#795548",
      "#9e9e9e",
      "#607d8b",
    ];
    let selectedChart = this.state.chart;
    return (
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div
          style={{
            width: "50%",
            display: "flex",
            flexDirection: "column",
            marginRight: 8,
          }}
        >
          {this.props.chart.chartType !== "Table" && (
            <FormControl component="fieldset" className={classes.formControl}>
              {this.props.chart.series.chartType === "PieChart" ? (
                <>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.props.chart.patterns}
                        onChange={(e) =>
                          this.props.handleChartChange({
                            ...this.props.chart,
                            patterns: e.target.checked,
                          })
                        }
                      />
                    }
                    label={this.props.t("report_pattern_to_pie")}
                  />
                </>
              ) : (
                <>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    <ClickAwayListener onClickAway={this.onClickAway}>
                      <div style={{ display: "flex" }}>
                        <Typography>
                          {this.props.t("report_series_colour")}
                        </Typography>
                        <div
                          style={{
                            padding: 5,
                            background: "#fff",
                            borderRadius: 1,
                            boxShadow: "0 0 0 1px rgba(0,0,0,0.1)",
                            display: "inline-block",
                            cursor: "pointer",
                            marginLeft: 10,
                          }}
                          onClick={(e) => this.onColourClick(e)}
                        >
                          <div
                            id="colour-swatch"
                            style={{
                              backgroundColor: `rgba(${this.state.color.r},${
                                this.state.color.g
                              },${this.state.color.b},${this.state.color.a})`,
                              cursor: "pointer",
                              height: 24,
                              width: 24,
                              borderRadius: 2,
                            }}
                          />
                        </div>
                        <Popper
                          open={Boolean(this.state.anchorEl)}
                          anchorEl={this.state.anchorEl}
                          placement={"bottom"}
                          className={classes.popper}
                          disablePortal
                          modifiers={{
                            flip: {
                              enabled: true,
                            },
                            preventOverflow: {
                              enabled: true,
                              escapeWithReference: false,
                            },
                          }}
                        >
                          <ChromePicker
                            color={this.state.color}
                            colors={colors}
                            onChange={(colour) => this.debounceColour(colour)}
                          />
                        </Popper>
                      </div>
                    </ClickAwayListener>
                    <div style={{ display: "flex" }}>
                      <FormControl
                        component="fieldset"
                        className={classes.formControl}
                      >
                        <TextField
                          className={classes.title}
                          fullWidth
                          id="x-axis-label"
                          label={this.props.t("report_xaxis_label")}
                          value={this.props.chart.xAxisTitle}
                          onChange={(event) =>
                            this.props.handleChartChange({
                              ...this.props.chart,
                              xAxisTitle: event.target.value,
                            })
                          }
                          margin="normal"
                        />
                      </FormControl>
                    </div>
                    <div style={{ display: "flex" }}>
                      <FormControl
                        component="fieldset"
                        className={classes.formControl}
                      >
                        <TextField
                          className={classes.title}
                          fullWidth
                          id="y-axis-label"
                          label={this.props.t("report_yaxis_label")}
                          value={this.props.chart.yAxisTitle}
                          onChange={(event) =>
                            this.props.handleChartChange({
                              ...this.props.chart,
                              yAxisTitle: event.target.value,
                            })
                          }
                          margin="normal"
                        />
                      </FormControl>
                    </div>
                  </div>
                </>
              )}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.props.chart.legend}
                      onChange={(e) =>
                        this.props.handleChartChange({
                          ...this.props.chart,
                          legend: e.target.checked,
                        })
                      }
                    />
                  }
                  label={this.props.t("report_include_chart_legend")}
                />
                <Collapse in={this.props.chart.legend}>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div>
                      <FormControl
                        component="fieldset"
                        className={classes.formControl}
                      >
                        <TextField
                          className={classes.title}
                          disabled={
                            this.props.chart.series.chartType === "PieChart"
                          }
                          fullWidth
                          required
                          label={this.props.t("report_chart_legend_label")}
                          value={this.props.chart.legendLabel}
                          onChange={(event) =>
                            this.props.handleChartChange({
                              ...this.props.chart,
                              legendLabel: event.target.value,
                            })
                          }
                          margin="normal"
                        />
                        {this.props.chart.series.chartType === "PieChart" && (
                          <FormHelperText>
                            {this.props.t("report_pie_label_not_modifiable")}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </div>
                    <div>
                      <FormControl
                        component="fieldset"
                        className={classes.formControl}
                      >
                        <FormLabel component="legend">
                          {this.props.t("report_legend_position")}
                        </FormLabel>
                        <RadioGroup
                          aria-label={this.props.t("report_legend_position")}
                          name="Position"
                          value={this.props.chart.legendPosition}
                          onChange={(e) =>
                            this.props.handleChartChange({
                              ...this.props.chart,
                              legendPosition: e.target.value,
                            })
                          }
                        >
                          <FormControlLabel
                            value="top"
                            control={<Radio />}
                            label={this.props.t("report_legend_position_top")}
                          />
                          <FormControlLabel
                            value="left"
                            control={<Radio />}
                            label={this.props.t("report_legend_position_left")}
                          />
                          <FormControlLabel
                            value="bottom"
                            control={<Radio />}
                            label={this.props.t(
                              "report_legend_position_bottom"
                            )}
                          />
                          <FormControlLabel
                            value="right"
                            control={<Radio />}
                            label={this.props.t("report_legend_position_right")}
                          />
                        </RadioGroup>
                      </FormControl>
                      <FormControl
                        component="fieldset"
                        className={classes.formControl}
                      >
                        <FormLabel component="legend">Align</FormLabel>
                        <RadioGroup
                          aria-label={this.props.t("report_legend_align")}
                          name="Align"
                          value={this.props.chart.legendAlign}
                          onChange={(e) =>
                            this.props.handleChartChange({
                              ...this.props.chart,
                              legendAlign: e.target.value,
                            })
                          }
                        >
                          <FormControlLabel
                            value="start"
                            control={<Radio />}
                            label={this.props.t("report_legend_align_start")}
                          />
                          <FormControlLabel
                            value="center"
                            control={<Radio />}
                            label={this.props.t("report_legend_align_centre")}
                          />
                          <FormControlLabel
                            value="end"
                            control={<Radio />}
                            label={this.props.t("report_legend_align_end")}
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </div>
                </Collapse>
              </div>
            </FormControl>
          )}
        </div>
        <div style={{ width: "50%", display: "flex", flexDirection: "row" }}>
          <Divider orientation="vertical" />
          <div style={{ marginLeft: 8 }}>
            {this.props.chart.chartType === "Table" ? (
              <FormControl component="fieldset" className={classes.formControl}>
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow>{this.getHeader()}</TableRow>
                  </TableHead>
                  <TableBody>{this.getRowsData()}</TableBody>
                </Table>
              </FormControl>
            ) : (
              <FormControl component="fieldset" className={classes.formControl}>
                {this.returnChart()}
              </FormControl>
            )}
          </div>
        </div>
      </div>
    );
  }

  onColourClick = (event) => {
    this.setState({
      anchorEl: this.state.anchorEl ? null : event.currentTarget,
      colorPopperOpen: !this.state.colorPopperOpen,
    });
  };

  onClickAway = () => {
    if (this.state.anchorEl) {
      this.setState({ anchorEl: null });
    }
  };

  debounceColour(color) {
    this.setState({ color: color.rgb });
    if (this.colorDebounce) {
      window.clearTimeout(this.colorDebounce);
    }
    this.colorDebounce = window.setTimeout(() => {
      this.props.handleChartChange({
        ...this.props.chart,
        color: color.rgb,
      });
      this.colorDebounce = null;
    }, 150);
  }

  onResize = (event, { element, size, handle }) => {
    this.props.handleChartChange({
      ...this.props.chart,
      width: size.width,
      height: size.height,
    });
  };
}
export default withTranslation()(withStyles(styles)(ChartStepFour));
